import { useAtom } from "jotai";
import { AppStateAtom } from "../../store";
import { useState } from "react";
import { subscribe } from "../../api/Subscribe";
import { useUser } from "../../hooks/useUser";
import { useNotifications } from "../../hooks/useNotifications";
import { trackMetaEvent, META_EVENTS } from "../../utils/metaPixel";
import { getAttribution, generateEventId } from "../../utils/attribution";
import {
  BillingPlan,
  setStoredSubscriptionPlan,
} from "../../utils/subscriptionPlan";

interface SubscriptionController {
  subscribe: (plan?: BillingPlan) => void;
  checkSubscription: () => void;

  loading: boolean;
}

export const useSubscriptionController = () => {
  const [appState] = useAtom(AppStateAtom);
  const [loading, setLoading] = useState(false);
  const notifications = useNotifications();
  const user = useUser();

  const performSubscribe = (plan: BillingPlan = "monthly") => {
    setLoading(true);
    setStoredSubscriptionPlan(plan);

    // Generate event ID for Meta deduplication
    const metaEventId = generateEventId();

    // Get attribution data
    const attribution = getAttribution();

    // Track Meta Pixel InitiateCheckout event
    trackMetaEvent(
      META_EVENTS.INITIATE_CHECKOUT,
      {
        content_name:
          plan === "annual"
            ? "WealthBee Annual Subscription"
            : "WealthBee Monthly Subscription",
        content_category: "subscription",
        billing_interval: plan,
      },
      metaEventId
    );

    subscribe(plan, metaEventId, attribution).then((res) => {
      if (res?.success === true) {
        window.location.href = res.session.url;
        setLoading(false);
      } else {
        notifications.createNotification("Something went wrong!", res?.message);

        setTimeout(() => {
          notifications.clearNotifications();
        }, 1600);

        setLoading(false);
      }
    });
  };

  const checkSubscriptionStatus = () => {
    console.log("Checking subscription status...", appState.subscriptionActive);

    if (appState.subscriptionActive === true) {
      subscribeSuccess();
    } else {
      user.refreshUserProfile();

      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  };

  const subscribeSuccess = () => {
    notifications.createNotification(
      "Subscription active",
      "You can now access all premium features!"
    );

    setTimeout(() => {
      notifications.clearNotifications();
    }, 1600);
    setLoading(false);
  };

  return {
    subscribe: performSubscribe,
    checkSubscription: checkSubscriptionStatus,
    loading,
  } as SubscriptionController;
};
